import { Component } from "@angular/core";
import { BaseComponent } from "../../shared";

@Component({
  selector: 'news',
  templateUrl: './newsComponent.html'
})
export class NewsComponent extends BaseComponent {
}